import { IPCameraChannel } from 'types/models/ip-camera';

export const normalizeChannelId = (channel: IPCameraChannel): IPCameraChannel | undefined => {
  const parsedId = Number(channel.id);
  if (!Number.isFinite(parsedId)) {
    return undefined;
  }
  return { ...channel, id: parsedId };
};
